export default __webpack_public_path__ + "static/media/16.bf4c7b85.png";